import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_umfa9a7xcn: FaireBrandEntity = {
  token: "b_umfa9a7xcn",
  type: "brand",
  name: "Jaymes Paper",
  avatarUrl:
    "https://cdn.faire.com/fastly/22642754fa778e110c51767c4e911847db70d7c6dfd91e20a62af7afc0c83d10.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a317770546403c7f2734fb0b2282e30c6a8903bce966837ae4dc7bef0d056cd7.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/22642754fa778e110c51767c4e911847db70d7c6dfd91e20a62af7afc0c83d10.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a317770546403c7f2734fb0b2282e30c6a8903bce966837ae4dc7bef0d056cd7.jpeg",
  location: "Santa Barbara, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 32,
  isTopShop: true,
  isInsider: true,
  description:
    "Jaymes Paper is a boutique stationery company based in Santa Barbara, California offering a collection of subtly sophisticated greeting cards for every occasion.\n\nFounded by Jaymee Harney in 2019, the company was created out of a deep fascination for all things paper and design. Over the years she has collected paper ephemera from various places, celebrations, & travels and has been making homemade cards for family & friends since 1997. It was a longtime dream of hers to create a collection of minimally designed stationery highlighting neutral tones and simple type. In a digital world of instant communication, we love that cards encourage us to sit down and write meaningful sentiments to those we love.\n\nWe work with various family owned printers located primarily in Los Angeles & Santa Barbara. Our letterpress cards are printed on a Heidelberg Windmill, an antique press that has been around since the early 1900s. We are fascinated by the old-fashioned art of printmaking and love utilizing this timeless technique as part of our process.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:56:19.576Z",
    importedBy: "entity-db-cli",
  },
};
